/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 24,
    viewBox: '0 0 16 24',
    data: '<path pid="0" d="M7.73 0a.813.813 0 00-.814.814v16.19l-5.514-5.77a.813.813 0 10-1.176 1.125l7.503 7.851 7.503-7.851a.815.815 0 00-1.176-1.125l-5.514 5.77V.814A.813.813 0 007.73 0zM14.238 22.373H1.22a.813.813 0 100 1.627h13.017a.813.813 0 100-1.627z" _fill="#000"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/download.js